var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-svgrepo-com",
    transform: "translate(-0.75 0.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21711",
    "data-name": "Group 21711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(0.75 -0.718)",
    fill: "#fff",
    stroke: "#156ae6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14765",
    fill: "#156ae6",
    stroke: "#156ae6",
    strokeWidth: 1,
    "data-name": "Path 14765",
    d: "M161.418,147.435H141.24a1.335,1.335,0,1,0,0,2.669h20.178a1.335,1.335,0,1,0,0-2.669Z",
    transform: "translate(-124.65 -123.653)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.f47b6568.svg";
export { ForwardRef as ReactComponent };